import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const sliderApi = createApi({
  reducerPath: 'sliderApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Slider'],
  endpoints: (builder) => ({
    getSliders: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/slider',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Slider'],
    }),
    addSlider: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-slider',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Slider'],
    }),
    updateSlider: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/update-slider',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Slider'],
    }),
    deleteSlider: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-slider',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Slider'],
    }),
  }),
});

export const {
  useGetSlidersQuery,
  useAddSliderMutation,
  useUpdateSliderMutation,
  useDeleteSliderMutation,
} = sliderApi;
